import OverviewSDK from '@/docs-partials/sdk/overview.mdx';
import * as React from 'react';
export default {
  OverviewSDK,
  React
};